import { Component } from '@angular/core';
import {MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {HttpService} from "../../services/http/http.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {NgIf} from "@angular/common";
import {ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'app-importazione-sedi',
  templateUrl: './importazione-sedi.component.html',
  styleUrls: ['./importazione-sedi.component.scss'],
  imports: [
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    ReactiveFormsModule
  ],
  standalone : true
})
export class ImportazioneSediComponent {
  constructor(
    public dialogRef: MatDialogRef<ImportazioneSediComponent>,
    public dialog: MatDialog,
    private api: HttpService,
    private snackBar : MatSnackBar
  ) {}


  onClose(): void {
    this.dialogRef.close();
  }

  procedi() : void {
    this.api.etlSedi().subscribe({
      next: () => {
        this.snackBar.open('Sedi importate con successo', 'close', { panelClass: 'successSnack' });
        this.dialogRef.close();
      }
    })
  }
}
